import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <FAQSection />
        <CarouselSection />
        <AboutSection />
        <CardsSection />
        <CommentsSection />
        <RankingSection />
        <IndexSection />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
        <ContactSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}